import React, { useCallback, useState } from "react";
import { useBreakpoint } from "hooks";
import TickIcon from "images/icons/tick-outline.inline.svg";
import InfoIcon from "images/icons/info-outline.inline.svg";
import CloseIcon from "images/icons/close-outline.inline.svg";

export const VIPriceSubCourseTable = ({ subCourses }) => {
  const breakpoint = useBreakpoint();
  const [viewMore, setViewMore] = useState(false);
  const [showInfo, setShowInfo] = useState([-1]);
  const handleInfo = useCallback(
    (selectedId, event) => () => {
      const index = showInfo.indexOf(selectedId);
      const newArrayState = showInfo.filter((value, theIndex) => {
        return value !== selectedId;
      });
      setShowInfo(index > -1 ? newArrayState : [...showInfo, selectedId]);
    },
    [showInfo]
  );

  return (
    <div className="">
      <div
        className={`!overflow-hidden pr-1 overflow-x ${
          viewMore
            ? "max-h-full"
            : "max-h-[90vh] md:max-h-full masked-overview masked-overview-down masked-overview_full md:masked-overview_disable"
        }`}
      >
        <table className="viprice-table viprice-subcourse-table table-fixed text-mob md:text-xl text-black-lighter dark:text-white transition-all duration-100 ease-in-out">
          <thead className="">
            <tr>
              <th className="w-[76%] md:w-[28%]"></th>
              <th className="w-[15%]"></th>
              {/* {["xs", "sm"].includes(breakpoint) ? (
                <></>
              ) : (
                <> */}
              <th className="w-[15%]"></th>
              <th className="w-[15%]"></th>
              <th className="w-[15%]"></th>
              <th className="w-[15%]"></th>
              <th className="w-[15%]"></th>
              {/* {" "}
                </>
              )} */}
            </tr>
          </thead>
          <tbody>
            {subCourses?.map((subCourse, index) => {
              const include = subCourse.include;
              const info = subCourse.moreInfo;
              const introSelect = subCourse.introSelect;
              const fullTimeSelect = subCourse.fullTimeSelect;
              const partTimeSelect = subCourse.partTimeSelect;
              const flexiSelect = subCourse.flexiSelect;
              const superFlexiSelect = subCourse.superFlexiSelect;

              return (
                <tr key={`tr-container-${index}`}>
                  <td className="border border-white dark:border-gray-lighter rounded-bl-[5px] text-base w-[24%] !pl-0 md:pl-4 overflow-hidden">
                    <div
                      className={`flex items-center md:justify-between md:gap-8 ${
                        showInfo?.indexOf(index) > -1
                          ? "bg-white dark:bg-gray-dark md:bg-transparent h-full md:h-auto"
                          : ""
                      }
                  `}
                    >
                      <p
                        className={`order-2 md:order-1 md:px-4 pl-3 md:pl-6 w-full md:w-auto text-mob text-base font-semibold ${
                          showInfo?.indexOf(index) > -1 ? "z-10" : ""
                        }`}
                      >
                        {showInfo?.indexOf(index) > -1 ? info : include}
                      </p>
                      {info && (
                        <div
                          className="group relative order-1 md:order-2 rounded-r-[5px] md:rounded-full p-3 md:p-2 md:mr-5 flex items-center bg-yellow-standard md:bg-transparent dark:bg-gray-standard h-full
                      after:z-0 after:absolute after:top-0 after:right-0 after:w-full after:h-full after:md:bg-white after:md:dark:bg-gray-standard after:transition-all after:duration-200 after:ease-in-out after:md:hover:scale-[20] after:rounded-full"
                          onMouseEnter={handleInfo(index, 1)}
                          onMouseLeave={handleInfo(index, 2)}
                        >
                          <button className="z-10" onClick={handleInfo(index)}>
                            {showInfo?.indexOf(index) > -1 &&
                            ["xs", "sm"].includes(breakpoint) ? (
                              <CloseIcon className="fill-white" />
                            ) : (
                              <InfoIcon className="fill-white dark:fill-gray-darken md:fill-yellow-lighten dark:group-hover:md:fill-white" />
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                  {!introSelect ? (
                    <td
                      className={`border border-white dark:border-gray-lighter ${
                        index > 1 ? "hidden md:table-cell" : ""
                      }`}
                      key={`td-intro-sel-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  ) : (
                    <td
                      className={`border border-white dark:border-gray-lighter w-[15%]`}
                      key={`td-intro-sel-alt-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  )}

                  {!fullTimeSelect ? (
                    <td
                      className={`border border-white dark:border-gray-lighter ${
                        index > 1 ? "hidden md:table-cell" : ""
                      }`}
                      key={`td-full-time-sel-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  ) : (
                    <td
                      className={`border border-white dark:border-gray-lighter w-[15%]`}
                      key={`td-full-time-sel-alt-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  )}

                  {!partTimeSelect ? (
                    <td
                      className={`border border-white dark:border-gray-lighter ${
                        index > 1 ? "hidden md:table-cell" : ""
                      }`}
                      key={`td-part-time-sel-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  ) : (
                    <td
                      className={`border border-white dark:border-gray-lighter w-[15%]`}
                      key={`td-part-time-sel-alt-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  )}

                  {!flexiSelect ? (
                    <td
                      className={`border border-white dark:border-gray-lighter ${
                        index > 1 ? "hidden md:table-cell" : ""
                      }`}
                      key={`td-flexi-sel-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  ) : (
                    <td
                      className={`border border-white dark:border-gray-lighter w-[15%]`}
                      key={`td-flexi-sel-alt-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  )}

                  {!superFlexiSelect ? (
                    <td
                      className={`border border-white dark:border-gray-lighter ${
                        index > 1 ? "hidden md:table-cell" : ""
                      }`}
                      key={`td-super-flexi-sel-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  ) : (
                    <td
                      className={`border border-white dark:border-gray-lighter w-[15%]`}
                      key={`td-super-flexi-sel-alt-${index}`}
                    >
                      <TickIcon className="mx-auto stroke-yellow-standard dark:stroke-white w-8 h-8" />
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <button
        className={`callback-button group flex justify-center items-center md:hidden px-20 py-2 mt-5 w-full bg-white hover:bg-black-lighter hover:text-white dark:bg-transparent dark:hover:bg-white dark:hover:text-gray-darker ${
          viewMore ? "hidden" : ""
        }`}
        onClick={() => setViewMore(true)}
      >
        <p className="pr-2">View more</p>
      </button>
    </div>
  );
};
